import React, { useEffect, useRef } from "react";
import { getHostAuthenticatorApiV2, getHostAuthenticatorApiV5 } from "../../externalApi/AuthenticatorApi";
import { getUserDisplayLocale } from "../../externalApi/DashboardHostApi";
import { getUserGeoName } from "../../externalApi/DashboardHostApiInternal";
import { getWidgetOrchestrator } from "../../widgetRuntime/orchestrator/orchestrator";
import { addMarkerToPageTimings } from "../../../telemetry/Measures";
import { isFeatureEnabled } from "../../externalApi/VelocityApi";
function addQueryParam(queryParamName, queryValue, widgetGroupProps) {
    if (queryParamName.length && queryValue.length) {
        if (widgetGroupProps.pcsAdditionalQsp.length) {
            widgetGroupProps.pcsAdditionalQsp += "&";
        }
        widgetGroupProps.pcsAdditionalQsp += queryParamName + "=" + queryValue;
    }
}
function addPcsDataToWidgetGroup(widgetGroupProps, widgetGroupPropsContainer) {
    const node = widgetGroupPropsContainer.current;
    if (node) {
        node.setAttribute("data-widget", JSON.stringify(widgetGroupProps));
    }
}
export async function getWidgetGroupAttrs(widgetGroupProps) {
    addMarkerToPageTimings("MEE.GetWidgetGroupAttrsStart");
    const urlParams = new URLSearchParams(window.location.search);
    // get displayLocale and geoName from url first, if not present, get from hostApi
    const displayLocale = urlParams.get("locale") || await getUserDisplayLocale();
    const geoName = urlParams.get("region") || await getUserGeoName();
    addQueryParam("locale", displayLocale || "en-us", widgetGroupProps); // TODO: Add error reporting/handling & proper fallback if hostApi doesn't work
    addQueryParam("region", geoName || "US", widgetGroupProps); // TODO: Add error reporting/handling & proper fallback if hostApi doesn't work
    if (isFeatureEnabled("Feature_AuthApiV5")) {
        const authenticator = await getHostAuthenticatorApiV5();
        if (authenticator) {
            // If we're signed in, get the provider authority of the signed in account. Otherwise use the default account for signed out/unknown.
            const signinStatus = await authenticator.getSignInStatus();
            let accountId = "";
            if (signinStatus === 1 /* SignedIn */) {
                accountId = await authenticator.getSignInTargetAccountId();
            }
            else {
                accountId = await authenticator.getDefaultAccountId();
            }
            const provider = accountId ? await authenticator.getAccountProperty(accountId, "ProviderAuthority") : "unknown";
            if (provider === "organizations") {
                addQueryParam("query", "enterprise", widgetGroupProps);
            }
        }
    }
    else {
        const authenticator = await getHostAuthenticatorApiV2();
        if (authenticator) {
            const accountId = await authenticator.getDefaultAccountId();
            const provider = accountId ? await authenticator.getAccountProperty(accountId, "ProviderAuthority") : "unknown";
            if (provider === "organizations") {
                addQueryParam("query", "enterprise", widgetGroupProps);
            }
        }
    }
    let orchestrator = await getWidgetOrchestrator();
    if (orchestrator.isUserRegionChina()) {
        widgetGroupProps.useCnDomain = true;
    }
    addMarkerToPageTimings("MEE.GetWidgetGroupAttrsEnd");
    return widgetGroupProps;
}
export const WidgetGroup = ({ appType, cm, pageType, pcsAdditionalQsp, useCnDomain }) => {
    const widgetGroupRef = useRef(null);
    useEffect(() => {
        let props = {
            appType,
            cm,
            pageType,
            pcsAdditionalQsp,
            useCnDomain,
        };
        props.clientPerf = {
            customPrefetchStrategy: "__com_microsoft_dsh_widget_promises.prefetchPcsInfo"
        };
        getWidgetGroupAttrs(props).then(widgetGroupProps => {
            addPcsDataToWidgetGroup(widgetGroupProps, widgetGroupRef);
        });
    }, []);
    return React.createElement("div", { className: "peregrine-widgetgroup", ref: widgetGroupRef });
};
